import { ResponseSchema } from '../../generic/response/response-schema';

export class DeleteUserResponseSchema extends ResponseSchema {
  static Defaults = class extends ResponseSchema.GenericDefaults {};
}
